<template>
  <footer class="AppFooter py-gr-6">
    <div class="container text-center">
      <div class="inline-block rounded-full px-gr-6 py-gr-half-6 bg-white dark:bg-black">
        <strong>Feedback, Questions, Support?</strong>
        <a
          class="link underline mx-gr-4 block sm:inline-block sm:mr-0"
          href="https://support.oneaudiobooks.app"
          target="_blank"
          rel="noopener"
          >Visit Our Support Page</a
        >
      </div>
    </div>
    <div class="mt-gr-7 container text-center text-sm">
      <span>
        &copy; Copyright {{ new Date().getFullYear() }}.
        <a href="https://oneaudiobooks.com/">ONE Audiobooks</a>. All Rights Reserved.
      </span>
      <small class="opacity-50">v{{ version }}</small>
      &nbsp;
      <subdomain-link :href="route('privacy.show')" class="link underline">Privacy</subdomain-link>
      &nbsp;
      <subdomain-link :href="route('terms.show')" class="link underline">Terms</subdomain-link>
    </div>
  </footer>
</template>

<script>
  import pkg from '../../../package.json';
  export default {
    name: 'AppFooter',

    data() {
      return {
        version: pkg.version,
      };
    },
  };
</script>

<!-- <style lang="scss" src="./AppFooter.scss" scoped></style> -->
